import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import RightsholderMaintenanceContactEdit from '@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceContactTab/RightsholderMaintenanceContactEdit'
import RightsholderMaintenanceContactView from '@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceContactTab/RightsholderMaintenanceContactView'
import { MAINTENANCE_TABS } from '@Const/tabs-constants'
import { StoresContext } from '@App/contexts'

const RightsholderMaintenanceContactTab = () => {
    const [pending, setPending] = useState(false)
    const [isEditable, setEditable] = useState(false)
    const { popupStore, rightsholderStore } = useContext(StoresContext)

    const checkPending = () => {
        const memberSummary = rightsholderStore.memberSummary
        if (memberSummary.pending) {
            popupStore.setTabsAlertData(
                'Your updates have been saved and are pending validation.\n' +
                    'Please check back in 24 hours to see changes reflected.',
                MAINTENANCE_TABS.mailingAndContact.name,
                false,
                true
            )
            setPending(true)
        } else {
            popupStore.setTabsAlertData('', MAINTENANCE_TABS.mailingAndContact.name, false, true)
            setPending(false)
        }
    }

    useEffect(checkPending, [])

    return isEditable ? (
        <RightsholderMaintenanceContactEdit pending={pending} checkPending={checkPending} setEditable={setEditable} />
    ) : (
        <RightsholderMaintenanceContactView pending={pending} setEditable={setEditable} />
    )
}

export default observer(RightsholderMaintenanceContactTab)
